<template>
    <v-container fluid>
        <v-row>
            <v-col class="pr-0 pl-0">
                <v-btn
                    color="indigo"
                    class="white--text"
                    :to="{
                        name: 'address.create',
                        params: {
                            reseller_id: reseller_id,
                        },
                    }"
                >
                    <v-icon left>mdi-plus</v-icon>
                    {{
                        $t('resources.default.add', {
                            resource: $tc('resources.address.name', 1),
                        })
                    }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pr-0 pl-0">
                <sarala-table :model="model" ref="table" :query="query">
                    <template #create-btn>
                        <v-row class="px-5 py-3">
                            <v-col>
                                <span class="overline">{{
                                    $tc('resources.address.name', 2)
                                }}</span>
                            </v-col>
                        </v-row>
                    </template>

                    <template #action="{ item }">
                        <template v-if="!item.deleted_at">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        tile
                                        v-on="on"
                                        :to="{
                                            name: 'address.edit',
                                            params: {
                                                id: item.id,
                                                reseller_id: item.reseller_id,
                                            },
                                        }"
                                    >
                                        <v-icon color="blue-grey" v-on="on"
                                            >mdi-pencil</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>{{ $t('form.actions.edit') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        tile
                                        v-on="on"
                                        @click="deleteItem(item)"
                                    >
                                        <v-icon color="red" v-on="on"
                                            >mdi-close</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>{{ $t('form.actions.delete') }}</span>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            <v-tooltip bottom v-if="!item.active">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        tile
                                        v-on="on"
                                        @click="restoreItem(item)"
                                    >
                                        <v-icon color="success" v-on="on"
                                            >mdi-recycle</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>{{ $t('form.actions.restore') }}</span>
                            </v-tooltip>
                        </template>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <confirm
            ref="confirmRemove"
            :confirmText="$t('dialogs-confirm.buttons.remove')"
            confirmColor="red darken-1"
            width="50%"
        ></confirm>
        <confirm
            ref="confirmRestore"
            :confirmText="$t('dialogs-confirm.buttons.restore')"
            confirmColor="green darken-1"
            width="50%"
        ></confirm>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Address from '@/models/Address'
import Confirm from '@/components/dialogs/Confirm'

export default {
    components: {
        SaralaTable,
        Confirm,
    },

    props: ['reseller_id'],

    computed: {
        model() {
            return new Address()
        },
    },

    methods: {
        query(model) {
            model.where('byReseller', this.reseller_id).where('trashed', 'with')
        },

        async deleteItem(model) {
            let confirm = await this.$refs.confirmRemove.open(
                this.$t('resources.dialogs.confirm.delete.title'),
                this.$t('resources.dialogs.confirm.delete.content', {
                    resource: this.$tc('resources.address.name', 1),
                    name: model.readableAddress,
                }),
            )

            if (!confirm) return

            let res = await model.delete()

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('resources.feedbacks.errors.delete', {
                        resource: this.$tc('resources.address.name', 1),
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.address.name', 1),
                }),
            )
        },

        async restoreItem(model) {
            let confirm = await this.$refs.confirmRestore.open(
                this.$t('resources.dialogs.confirm.restore.title'),
                this.$t('resources.dialogs.confirm.restore.content', {
                    resource: this.$tc('resources.address.name', 1),
                    name: model.readableAddress,
                }),
            )

            if (!confirm) return

            let res = await model.restore()

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('resources.feedbacks.errors.restore', {
                        resource: this.$tc('resources.address.name', 1),
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.restore', {
                    resource: this.$tc('resources.address.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
